import { Image } from "../../../_ui";

const ImageAnswer = ({answer}: {answer: TResponse}) => {  
  return(
    <Image src={answer.img} style={{ borderRadius: 10 }} width={128} height={128} />
  )
}

export default ImageAnswer;